import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CustomerLoanStatus, CustomerLoanStatusLabel } from 'common';
import { AccountStatusIconChipModel } from './account-status-icon-chip.model';

@Component({
    selector: 'ifp-account-status-icon-chip',
    templateUrl: './account-status-icon-chip.component.html',
    styleUrls: ['./account-status-icon-chip.component.css'],
    standalone: false
})
export class AccountStatusIconChipComponent implements OnChanges {

  @Input()
  accountStatusIconChipModel: AccountStatusIconChipModel;

  @Input()
  status: CustomerLoanStatus;

  statusLabels: any;

  constructor() {
    this.Init();
  }

  ngOnChanges(_: SimpleChanges): void {
    this.Init();
  }

  private Init() {

    this.statusLabels = {
      'pending': { color: 'mat-grey-bg', icon: 'help'},
      'open': { color: 'mat-green-bg', icon: 'check_circle' },
      'closed': { color: 'mat-red-bg', icon: 'error' },
      'repayment': { color: 'mat-orange-bg', icon: 'check_circle'},
      'payment-due': { color: 'mat-orange-bg', icon: 'check_circle'},
      'pending-renewal': { color: 'mat-orange-bg', icon: 'update'},
      'pending-closure': { color: 'mat-red-bg', icon: 'error' },
      'renewed': { color: 'mat-red-bg', icon: 'error' },
      'frozen-missing-payment': { color: 'mat-orange-bg', icon: 'pause_circle_filled' },
      'paid-off': { color: 'mat-red-bg', icon: 'error' },
      'needs-attention': { color: 'mat-orange-bg', icon: 'warning', tooltip: this.accountStatusIconChipModel?.needsAttentionMessage },
    };

    Object.keys(this.statusLabels).forEach(status => {
      this.statusLabels[status].label = CustomerLoanStatusLabel.get(status);
    });
  }
}
